export enum VITE_MODE {
  'PRODUCTION' = 'production',
  'DEVELOPMENT' = 'development',
}
